// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '@/plugins';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2'
import App from './App'
import router from './router' //路由
import '../static/css/base.css'; //公共样式
import '../static/css/ele.css'; //ele修改样式
import VueCookie from 'vue-cookie'

Vue.use(VueCookie)
Vue.use(VueClipboard)

import store from '@/store'; //Vuex
Vue.prototype.$store = store;
import apiInterface from "@/api/apiInterface"; //api
import enumInfo from "@/api/enum"; // 枚举
Vue.prototype.$interface = apiInterface.Interface;
Vue.prototype.$enumInfo = enumInfo.cardhobby;
import { post, get } from "@/api/axiosConfig"; // ajax请求封装
Vue.prototype.$get = get;
Vue.prototype.$post = post;

Vue.use(ElementUI, { locale });
Vue.config.productionTip = false



router.beforeEach((to, from, next) => {

  //store.dispatch('isToken')
  console.log(to.name)
  // store.dispatch("userLog");
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title+' - MIAO'
  }
  next()
})



/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js